(() => {
  if (customElements.get('dd-dreh-360')) return;

  const mitBreite = (url, w) => url + (url.includes('?') ? '&' : '?') + 'width=' + w;

  class DdDreh360 extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      let urls;
      try {
        urls = this.dataset.urls ? JSON.parse(this.dataset.urls) : this.urlsBauen();
      } catch (e) {
        urls = [];
      }
      if (!Array.isArray(urls[0])) urls = [urls];
      this.reihen = urls;
      this.anzahl = urls[0].length;
      if (this.anzahl < 2) return;
      this.bereit = true;
      this.mitte = Math.max(0, Math.min(urls.length - 1, Number(this.dataset.mitte || (urls.length - 1) / 2)));

      this.flaeche = this.querySelector('.dd-dreh__flaeche');
      this.griff = this.querySelector('.dd-dreh__griff');
      this.punkt = this.querySelector('.dd-dreh__punkt');
      this.ctx = this.flaeche.getContext('2d');
      this.bilder = urls.map(() => new Array(this.anzahl));
      this.scharf = new Map();
      this.unterwegs = new Set();
      this.warteschlange = [];
      this.offen = 0;
      this.geladen = 0;
      this.stand = 0;
      this.reihe = this.mitte;
      this.zoom = 1;
      this.tempo = [0, 0];
      this.finger = new Map();
      this.ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slide = this.closest('.swiper-slide');
      this.fensterHuelle = this.closest('.dd-vm');

      const pruefen = () => {
        const aktiv =
          (!this.fensterHuelle || this.fensterHuelle.classList.contains('active')) &&
          (!this.slide ||
            this.slide.classList.contains('is-active') ||
            this.slide.classList.contains('swiper-slide-active'));
        this.sichtbar = this.imBild && aktiv;
        if (this.sichtbar) {
          this.bildFreigeben();
          if (this.fensterHuelle && !this.ladeStart) {
            clearTimeout(this.ladeTimer);
            this.ladeTimer = setTimeout(() => {
              if (this.sichtbar) this.laden(this.mitte);
            }, 320);
          } else {
            this.laden(this.mitte);
          }
          this.lauf();
        }
      };
      new IntersectionObserver(
        (e) => {
          this.imBild = e.some((x) => x.isIntersecting);
          pruefen();
        },
        { threshold: 0.35 }
      ).observe(this);
      if (this.slide) new MutationObserver(pruefen).observe(this.slide, { attributes: true, attributeFilter: ['class'] });
      if (this.fensterHuelle) new MutationObserver(pruefen).observe(this.fensterHuelle, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(pruefen).observe(this, { attributes: true, attributeFilter: ['hidden'] });
      new ResizeObserver(() => this.groesse()).observe(this);

      this.griff.addEventListener('pointerdown', (e) => this.start(e));
      this.griff.addEventListener('pointermove', (e) => this.ziehen(e));
      this.griff.addEventListener('pointerup', (e) => this.ende(e));
      this.griff.addEventListener('pointercancel', (e) => this.ende(e));
      this.griff.addEventListener('click', (e) => e.stopPropagation());
      const zurueck = this.querySelector('.dd-dreh__zurueck');
      if (zurueck)
        zurueck.addEventListener('click', (e) => {
          e.stopPropagation();
          this.zuruecksetzen();
        });
    }

    urlsBauen() {
      const d = this.dataset;
      if (!d.erstes || !d.praefix) return [];
      const anzahl = Number(d.anzahl || 48);
      const reihen = Number(d.reihen || 0);
      const endung = d.endung || 'webp';
      const fragezeichen = d.erstes.indexOf('?');
      const ohneFrage = fragezeichen >= 0 ? d.erstes.slice(0, fragezeichen) : d.erstes;
      const anhang = fragezeichen >= 0 ? d.erstes.slice(fragezeichen) : '';
      const basis = ohneFrage.slice(0, ohneFrage.lastIndexOf('/') + 1);
      const stellen = anzahl > 100 ? 3 : 2;
      const zeilen = [];
      for (let r = 0; r <= Math.max(reihen - 1, 0); r++) {
        const zeile = [];
        for (let i = 0; i < anzahl; i++) {
          const nummer = String(i).padStart(stellen, '0');
          let name;
          if (reihen > 0) {
            let praefix = d.praefix;
            let index = r;
            if (d.praefixZwischen) {
              index = Math.floor(r / 2);
              if (r % 2 === 1) praefix = d.praefixZwischen;
            }
            name = praefix + String(index).padStart(2, '0') + '-' + nummer + '.' + endung;
          } else {
            name = d.praefix + nummer + '.' + endung;
          }
          zeile.push(basis + name + anhang);
        }
        zeilen.push(zeile);
      }
      return zeilen;
    }

    breite() {
      return 800;
    }

    bildFreigeben() {
      const bild = this.querySelector('.dd-dreh__bild[data-src]');
      if (!bild) return;
      bild.src = bild.dataset.src;
      bild.removeAttribute('data-src');
    }

    ladeStand() {
      const balken = this.querySelector('.dd-dreh__lade > span');
      if (!balken) return;
      const ziel = Math.min(this.anzahl, 48);
      const da = Math.min(this.bilder[this.mitte].filter(Boolean).length, ziel);
      balken.style.width = Math.round((da / ziel) * 100) + '%';
      if (da >= ziel) this.classList.add('ist-geladen');
    }

    einzeln(r, i, breite) {
      if (r < 0 || r >= this.reihen.length) return;
      const schluessel = r + '-' + i;
      if (this.bilder[r][i] || this.unterwegs.has(schluessel)) return;
      this.unterwegs.add(schluessel);
      this.warteschlange.push([r, i, breite || this.breite()]);
      this.pumpe();
    }

    pumpe() {
      while (this.offen < 12 && this.warteschlange.length) {
        const [r, i, breite] = this.warteschlange.shift();
        const bild = new Image();
        bild.decoding = 'async';
        bild.src = mitBreite(this.reihen[r][i], breite);
        this.offen++;
        bild
          .decode()
          .then(() => {
            this.bilder[r][i] = bild;
            this.geladen++;
            if (r === this.mitte) this.ladeStand();
            if (!this.classList.contains('ist-bereit') || r === Math.round(this.reihe)) this.zeichnen(true);
          })
          .catch(() => {})
          .finally(() => {
            this.offen--;
            this.pumpe();
          });
      }
    }

    laden(r) {
      if (!this.ladeStart) this.ladeStart = new Set();
      if (r < 0 || r >= this.reihen.length || this.ladeStart.has(r)) return;
      this.ladeStart.add(r);
      const breite = this.breite();
      const folge = [];
      [8, 4, 2, 1].forEach((schritt) => {
        for (let i = 0; i < this.anzahl; i += schritt) if (!folge.includes(i)) folge.push(i);
      });
      const [, jetzt] = this.aktuell();
      folge.sort((a, b) => {
        const da = Math.min(Math.abs(a - jetzt), this.anzahl - Math.abs(a - jetzt));
        const db = Math.min(Math.abs(b - jetzt), this.anzahl - Math.abs(b - jetzt));
        return (a % 8 === 0 ? 0 : 1) - (b % 8 === 0 ? 0 : 1) || da - db;
      });
      folge.forEach((i) => this.einzeln(r, i, breite));
    }

    spalteLaden() {
      const [r0, i] = this.aktuell();
      if (this.letzteSpalte === i) return;
      this.letzteSpalte = i;
      const reihen = [...this.reihen.keys()].sort((a, b) => Math.abs(a - r0) - Math.abs(b - r0));
      const vorne = this.warteschlange.length;
      reihen.forEach((r) => this.einzeln(r, i));
      const neu = this.warteschlange.splice(vorne);
      this.warteschlange.unshift(...neu);
      this.pumpe();
    }

    aktuell() {
      const i = ((Math.round(this.stand) % this.anzahl) + this.anzahl) % this.anzahl;
      const r = Math.round(this.reihe);
      return [r, i];
    }

    naechstes(r, i) {
      const zeile = this.bilder[r];
      if (zeile[i]) return zeile[i];
      for (let d = 1; d < this.anzahl; d++) {
        const a = zeile[(i + d) % this.anzahl] || zeile[(i - d + this.anzahl) % this.anzahl];
        if (a) return a;
      }
      for (let dr = 1; dr < this.reihen.length; dr++) {
        for (const rr of [r - dr, r + dr]) {
          if (rr >= 0 && rr < this.reihen.length && this.bilder[rr][i]) return this.bilder[rr][i];
        }
      }
      return null;
    }

    zeichnen(immer) {
      this.punktSetzen();
      const [r, i] = this.aktuell();
      const schluessel = r + '-' + i;
      const bild = (this.zoom > 1.15 && this.scharf.get(schluessel)) || this.naechstes(r, i);
      if (!bild || !this.flaeche.width) return;
      if (!immer && bild === this.letztesBild && this.zoom === this.letzterZoom) return;
      this.letztesBild = bild;
      this.letzterZoom = this.zoom;
      const w = this.flaeche.width;
      const h = this.flaeche.height;
      const s = Math.min(w / bild.naturalWidth, h / bild.naturalHeight) * this.zoom;
      const bw = bild.naturalWidth * s;
      const bh = bild.naturalHeight * s;
      this.ctx.imageSmoothingQuality = 'high';
      this.ctx.clearRect(0, 0, w, h);
      this.ctx.drawImage(bild, (w - bw) / 2, (h - bh) / 2, bw, bh);
      this.classList.add('ist-bereit');
      if (this.zoom > 1.15) this.scharfLaden(r, i);
    }

    scharfLaden(r, i) {
      const schluessel = r + '-' + i;
      if (this.scharf.has(schluessel)) return;
      this.scharf.set(schluessel, null);
      const bild = new Image();
      bild.decoding = 'async';
      bild.src = mitBreite(this.reihen[r][i], 1200);
      bild
        .decode()
        .then(() => {
          this.scharf.set(schluessel, bild);
          if (Math.round(this.reihe) === r) this.zeichnen(true);
        })
        .catch(() => this.scharf.delete(schluessel));
    }

    punktSetzen() {
      if (!this.punkt) return;
      const winkel = (this.stand / this.anzahl) * Math.PI * 2;
      const vorn = Math.cos(winkel);
      const kipp = this.reihen.length > 1 ? (this.reihe - this.mitte) / Math.max(this.mitte, 1) : 0;
      this.punkt.setAttribute('cx', (12 + 10.5 * Math.sin(winkel)).toFixed(2));
      this.punkt.setAttribute('cy', (12 + 4 * vorn + 5 * kipp).toFixed(2));
      this.punkt.setAttribute('opacity', vorn < 0 ? '0.35' : '1');
    }

    groesse() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = Math.round(this.clientWidth * dpr);
      const h = Math.round(this.clientHeight * dpr);
      if (!w || !h) return;
      if (this.flaeche.width !== w || this.flaeche.height !== h) {
        this.flaeche.width = w;
        this.flaeche.height = h;
        this.zeichnen(true);
      }
    }

    wackeln() {
      if (this.ruhig) return;
      this.rueck = null;
      this.tempo = [0, 0];
      this.stand = Math.round(this.stand / this.anzahl) * this.anzahl;
      this.teaserFertig = false;
      this.teaserStart = null;
      this.zeichnen(true);
      this.lauf();
    }

    zoomSetzen(z) {
      this.zoom = Math.max(1, Math.min(2, z));
      this.classList.toggle('gezoomt', this.zoom > 1.02);
      this.teaserFertig = true;
      this.zeichnen(true);
    }

    zuruecksetzen() {
      const ziel = Math.round(this.stand / this.anzahl) * this.anzahl;
      this.rueck = { t0: performance.now(), stand: this.stand, ziel, reihe: this.reihe, zoom: this.zoom };
      this.tempo = [0, 0];
      this.teaserFertig = true;
      this.lauf();
    }

    start(e) {
      this.finger.set(e.pointerId, [e.clientX, e.clientY]);
      this.griff.setPointerCapture(e.pointerId);
      this.teaserFertig = true;
      this.rueck = null;
      if (this.finger.size > 1) {
        this.zieht = false;
        return;
      }
      this.zieht = true;
      this.tempo = [0, 0];
      this.letzt = [e.clientX, e.clientY, performance.now()];
      this.classList.add('ist-benutzt', 'zieht');
      this.laden(this.mitte);
      this.lauf();
    }

    ziehen(e) {
      if (this.finger.has(e.pointerId)) this.finger.set(e.pointerId, [e.clientX, e.clientY]);
      if (!this.zieht) return;
      const jetzt = performance.now();
      const proPixel = this.anzahl / (this.clientWidth * 1.1 * this.zoom);
      const proReihe = ((this.clientWidth * 1.05) / this.reihen.length) * this.zoom;
      const dx = (e.clientX - this.letzt[0]) * proPixel;
      const dy = -(e.clientY - this.letzt[1]) / proReihe;
      const dt = Math.max(jetzt - this.letzt[2], 1);
      this.stand += dx;
      this.reihe = Math.max(0, Math.min(this.reihen.length - 1, this.reihe + dy));
      if (Math.abs(e.clientY - this.letzt[1]) > Math.abs(e.clientX - this.letzt[0])) this.spalteLaden();
      else this.laden(Math.round(this.reihe));
      this.tempo = [dx / dt, 0];
      this.letzt = [e.clientX, e.clientY, jetzt];
      this.zeichnen();
    }

    ende(e) {
      if (e) this.finger.delete(e.pointerId);
      if (this.finger.size < 2) this.pinch = null;
      if (!this.zieht) return;
      this.zieht = false;
      this.classList.remove('zieht');
      this.laden(Math.round(this.reihe));
      if (performance.now() - this.letzt[2] > 80) this.tempo = [0, 0];
    }

    lauf() {
      if (this.laeuft) return;
      this.laeuft = true;
      let vorher = performance.now();
      const schritt = (jetzt) => {
        const dt = Math.min(jetzt - vorher, 50);
        vorher = jetzt;
        if (!this.sichtbar && !this.zieht) {
          this.laeuft = false;
          return;
        }
        if (!this.zieht && this.rueck) {
          const t = Math.min((jetzt - this.rueck.t0) / 600, 1);
          const w = 1 - Math.pow(1 - t, 3);
          this.stand = this.rueck.stand + (this.rueck.ziel - this.rueck.stand) * w;
          this.reihe = this.rueck.reihe + (this.mitte - this.rueck.reihe) * w;
          this.zoom = this.rueck.zoom + (1 - this.rueck.zoom) * w;
          this.classList.toggle('gezoomt', this.zoom > 1.02);
          this.zeichnen();
          if (t >= 1) {
            this.stand = 0;
            this.rueck = null;
            this.zeichnen(true);
          }
        } else if (!this.zieht) {
          if (Math.abs(this.tempo[0]) > 0.0005) {
            this.stand += this.tempo[0] * dt;
            this.tempo[0] *= Math.pow(0.94, dt / 16.7);
            this.zeichnen();
          } else {
            this.tempo = [0, 0];
            const ziel = Math.round(this.stand);
            if (this.teaserFertig && Math.abs(ziel - this.stand) > 0.001) {
              this.stand += (ziel - this.stand) * Math.min(1, dt / 90);
              if (Math.abs(ziel - this.stand) < 0.02) this.stand = ziel;
              this.zeichnen();
            }
            const zeile = this.bilder[this.mitte];
            const voll = zeile.filter(Boolean).length >= Math.min(this.anzahl, 48);
            if (!this.ruhig && !this.teaserFertig && voll) {
              if (this.teaserStart == null) {
                this.teaserStart = jetzt;
                this.teaserVon = this.stand;
              }
              const t = Math.min((jetzt - this.teaserStart) / 1400, 1);
              this.stand = this.teaserVon + (this.anzahl / 8) * Math.sin(t * Math.PI * 2) * Math.pow(1 - t, 0.6);
              this.zeichnen();
              if (t >= 1) this.teaserFertig = true;
            }
          }
        }
        requestAnimationFrame(schritt);
      };
      requestAnimationFrame(schritt);
    }
  }

  customElements.define('dd-dreh-360', DdDreh360);

  if (!customElements.get('dd-3d-overlay')) {
    class Dd3dOverlay extends HTMLElement {
      connectedCallback() {
        if (this.bereit) return;
        this.bereit = true;
        this.fenster = this.querySelector('.dd-vm');
        this.knopf = this.querySelector('.dd-3d-knopf');
        if (!this.fenster || !this.knopf) return;
        document.body.appendChild(this.fenster);
        this.knopf.addEventListener('click', (e) => {
          e.stopPropagation();
          this.oeffnen();
        });
        this.addEventListener('pointerdown', (e) => e.stopPropagation());
        this.fenster.querySelector('.dd-vm__close')?.addEventListener('click', () => this.schliessen());
        this.fenster.querySelector('.dd-vm__zurueck')?.addEventListener('click', () => this.aktiv()?.zuruecksetzen());
        this.fenster.querySelectorAll('.dd-vm__thumb').forEach((w) => w.addEventListener('click', () => this.waehlen(Number(w.dataset.index))));
        this.fenster.addEventListener('click', (e) => {
          if (e.target === this.fenster) this.schliessen();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.fenster.classList.contains('active')) this.schliessen();
        });
      }

      ansichten() {
        return [...this.fenster.querySelectorAll('dd-dreh-360')];
      }

      aktiv() {
        return this.ansichten().find((a) => !a.hidden);
      }

      waehlen(i) {
        this.ansichten().forEach((a, k) => (a.hidden = k !== i));
        this.fenster.querySelectorAll('.dd-vm__thumb').forEach((w, k) => w.setAttribute('aria-pressed', String(k === i)));
        this.wackelnLassen();
      }

      wackelnLassen() {
        clearTimeout(this.wackelTimer);
        this.wackelTimer = setTimeout(() => this.aktiv()?.wackeln?.(), 350);
      }

      oeffnen() {
        this.fenster.querySelectorAll('.dd-vm__thumb img[data-src]').forEach((bild) => {
          bild.src = bild.dataset.src;
          bild.removeAttribute('data-src');
        });
        this.letzterFokus = document.activeElement;
        this.fenster.classList.add('active');
        this.fenster.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden', 'dd-3d-offen');
        this.fenster.querySelector('.dd-vm__close')?.focus({ preventScroll: true });
        this.wackelnLassen();
      }

      schliessen() {
        this.fenster.classList.remove('active');
        this.fenster.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden', 'dd-3d-offen');
        this.letzterFokus?.focus?.({ preventScroll: true });
      }
    }
    customElements.define('dd-3d-overlay', Dd3dOverlay);
  }
})();
